import { useContext } from "react";
import { Context } from ".";

const useLibrary = () => {
	const library = useContext(Context);
	return library;
};

export default useLibrary;
